<div class="container">
  <app-admin-sidenav></app-admin-sidenav>
  <div class="content" [ngClass]="{ 'content-fluid': fluidContainer }">
    <router-outlet></router-outlet>
  </div>
</div>
